import { Typography } from "@mui/material";

const RecaptchaTerms = () => {
  if (import.meta.env.VITE_RECAPTCHA_KEY) {
    return (
      <Typography style={{ paddingTop: 10, fontSize: 10, textAlign: "center" }}>
        This site is protected by reCAPTCHA and the Google{" "}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </Typography>
    );
  }

  return null;
};

export default RecaptchaTerms;
